type Extensions = 'png' | 'jpg' | 'svg'

export function getImageUrl(pathName: string, extension: Extensions = 'png') {
  return `https://claravine-public-prod.s3-us-west-2.amazonaws.com/images/${pathName}.${extension}`
}
